const config = {
    version: "v2",
    api_url: process.env.REACT_APP_BASE_URL || ""
}
export default config;